import { ThunkType } from "../../../../../core/store/reducers";
import { getTradeByClientsReport } from "../api/getTradeByClientsReport";
import fileDownload from "js-file-download";
import { setFetchState } from "../tradeByClientsDataSlice";

export const downloadTradeByClientsReport = (): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const { filter } = store.ux.reports.exchbusiness.tradeByClients;
  const user = store.data.auth.current.user;
  dispatch(setFetchState({ type: "started" }));
  const ordersReport = await dispatch(getTradeByClientsReport(user, filter));
  if (ordersReport) {
    fileDownload(
      new Blob([ordersReport as any], { type: "application/pdf" }),
      "TradeByClients.pdf"
    );
  }
  dispatch(setFetchState({ type: "not-started" }));
};
